if (!window.__hubspotConsultModalInit) {
  window.__hubspotConsultModalInit = true;

  var TARGET_TEXTS = [
    'book a visit for your personalized pack',
    'contact us',
    'book a health coach',
  ];
  var HUBSPOT_SCRIPT_SRC = '//js.hsforms.net/forms/embed/v2.js';
  var formLoaded = false;

  function normalize(text) {
    return (text || '').trim().toLowerCase();
  }

  function isTargetLink(el) {
    return el && el.tagName === 'A' && TARGET_TEXTS.indexOf(normalize(el.textContent)) !== -1;
  }

  function loadHubspotScript(callback) {
    if (window.hbspt) {
      callback();
      return;
    }
    var script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_SRC;
    script.charset = 'utf-8';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function renderForm() {
    if (formLoaded) return;
    formLoaded = true;
    window.hbspt.forms.create({
      portalId: '46526182',
      formId: '6fb45b91-f05d-44ac-9ec1-fc8852222e43',
      region: 'na1',
      sfdcCampaignId: '701Ro0000096qlFIAQ',
      target: '#hubspot-consult-form',
    });
  }

  function openModal() {
    var modal = document.getElementById('hubspot-consult-modal');
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    loadHubspotScript(renderForm);
  }

  function closeModal() {
    var modal = document.getElementById('hubspot-consult-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (isTargetLink(link)) {
      event.preventDefault();
      openModal();
      return;
    }
    if (event.target.closest('[data-hubspot-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
}
